import { useMutation } from 'react-query';
import { useAuth } from 'context/auth';

export const handlePasswordResetRequestMutation = {
  onSuccess: () => {},
  throwOnError: true,
};

export const usePasswordResetRequest = () => {
  const { resetPasswordRequest } = useAuth();

  return useMutation(
    (values) => resetPasswordRequest(values),
    handlePasswordResetRequestMutation
  );
};
